import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { MiContentResponse } from '../model/types';

export const getMobileInventorAppContentAPI = async () => {
  const response = await baseAPI.get<MiContentResponse>(
    'mobile-inventor-push/content',
  );
  return response.data;
};

export const getMobileInventorAppContentOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: QUERY_KEYS.MOBILE_INVENTOR_PUSH_CONTENT(),
    queryFn: getMobileInventorAppContentAPI,
    enabled,
  });

export const useGetMobileInventorAppContent = (enabled: boolean) =>
  useQuery(getMobileInventorAppContentOptions(enabled));
